<template>

  <div class="commission-details" ref="container">
    <div class="user">
      <div class="wrapper">
        <div class="myService baCololCom"  style="background-color: #ec5d59 !important;">
          <div class="title acea-row row-middle">我的收益（已发：{{userInfo.bonusEd || 0}} 待发：{{userInfo.bonusWill || 0}} ）</div>
          <div class="nav acea-row row-middle baCololCom" style="background-color: #ec5d59 !important;">

            <div class="item" >
              <div>今日收益</div>
              <div class="num">{{ userInfo.todayBonus || 0}}</div>
            </div>
            <div class="item" >
              <div>昨日收益</div>
              <div class="num">{{ userInfo.yesdayBonus || 0}}</div>
            </div>
            <!--<router-link :to="{ path: '/user/commission/' + userInfo._add_day }" class="item" >
              <div>今日收益</div>
              <div class="num">{{ userInfo.todayBonus || 0}}</div>
            </router-link>
            <router-link :to="{ path: '/user/commission/' + userInfo._yestoday_day }" class="item" >
              <div>昨日收益</div>
              <div class="num">{{ userInfo.yesdayBonus || 0}}</div>
            </router-link>-->
            <router-link :to="{ path: '/user/commission_week' }" class="item" >
              <div>7日收益</div>
              <div class="num">{{ userInfo.weekBonus || 0}}</div>
            </router-link>
          </div>
          <div class="nav acea-row row-middle baCololCom" style="background-color: #ec5d59 !important;">
            <router-link :to="{ path: '/user/commission_day/' + userInfo._add_month }" class="item"  >
              <div>本月收益</div>
              <div class="num">{{ userInfo.tomonthBonus || 0}}</div>
            </router-link>
            <router-link :to="{ path: '/user/commission_day/' + userInfo._yest_month }" class="item"  >
              <div>上月收益</div>
              <div class="num">{{ userInfo.yesmonthBonus || 0}}</div>
            </router-link>
            <router-link :to="{ path: '/user/commission_month' }" class="item"  >
              <div>总收益</div>
              <div class="num">{{ userInfo.allBonus || 0}}</div>
            </router-link>
          </div>
        </div>
      </div>

    </div>
    <div class="sign-record">
      <div class="list"  v-if="info.length > 0">
        <div class="item" v-for="(item, index) in info" :key="index">
          <div class="data">{{ item._add_month }} <router-link  :to="{ path: '/user/commission_day/' + item._add_month }" style="float:right;" class="bonus_show">明细</router-link></div>
          <div class="listn">
          <div class="itemn acea-row row-between-wrapper">

            <div class="name line1" style="width:50%;">汇总</div>
            <div style="float:right;width:50%;text-align:right;" class="num">
              {{item['all_money']}}
              <br />
              <span style="color:#666;font-size:0.3rem;">待发：{{item['bonusWill']}}</span>
            </div>

          </div>
        </div>

          <div class="listn" v-for="(val, key) in allBonus" :key="key">
            <div class="itemn acea-row row-between-wrapper" v-if="item[val['id']]>0">

                <div class="name line1" style="width:50%;">{{ val.name }}</div>
                <div style="float:right;width:50%;text-align:right;color:#666;" class="num">
                  {{item[val['id']]}}
                </div>
            </div>
          </div>



        </div>
      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>


    </div>



    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style scoped>
.footer-line-height {
  height: 1rem;
}
.baCololCom {
  background-color:#ec5d59 !important;
  color:#fff;
}
.baCololCom div{
  color:#fff !important;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.user .wrapper .myService {
  margin-bottom:0.15rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
<style>
  .sign-record .list .item .listn th{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn .listntime {
    padding-left:0.15rem;
  }
  .sign-record .list .item .listn td{
    padding:0.30rem 0px;
  }
  .sign-record .list .item .listn{
    font-size: 0.28rem;
    color: #282828;

  }
  .sign-record .list .item .listn2{
    border-bottom:1px solid #eee;
  }
  .bonus_show {
    color:#ec5d59;
    font-size:0.2rem;
  }
</style>

<script>
import {  getUser,getBonusListMonth } from "../../../api/user";
import Loading from "@components/Loading";
const NAME = "CommissionDetailsMonth";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      showno:1,
      userInfo: {},
      info: [],
        allBonus:[],
      commission: 0,
        allBonusCountCan:2,

      where: {
        page: 1,
        limit: 20
      },
      types: 3,
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    this.User();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getBonusListMonth(that.where).then(
        res => {
          that.loading = false;

          that.allBonus = res.data.allBonus;
          that.loaded = res.data.list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data.list);
          that.commission = res.data.allmoney;
          if(that.info.length==0){
            that.showno=0;
          }
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
